import { apiClient } from './authService';

// Notes du tableau de bord — shared discussion thread between the accounts.
const noteService = {
  // Last 200 notes, oldest first (chat order).
  getNotes: async () => {
    const response = await apiClient.get('notes/');
    return response.data;
  },

  addNote: async (content) => {
    const response = await apiClient.post('notes/', { content });
    return response.data;
  },

  // Own note only (admin can delete any) — enforced server-side.
  deleteNote: async (id) => {
    await apiClient.delete(`notes/${id}/`);
  },
};

export default noteService;
